import React, { Component } from 'react';
import {numberParce} from '../../../../server/util'
class TotalMealServed extends Component {
    constructor(props){
        super(props);
    }
    render() {
        const {data}=this.props
        return (
            <div className="mini-stat bg-2 clearfix rounded text-center">
                <span className="mini-stat-icon" style={{float:'none'}}><i className="fa fa-cutlery fg-2"></i></span>
                <div className="mini-stat-info">
                    Total Meal Served
                    {data.loading?<span className='loading'></span>:<span>{numberParce(((data.data||{}).Meal||{}).totalCount)}</span>}
                </div>
            </div>
        );
    }
}
export default TotalMealServed;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/DashboardItems/totalMealServed.jsx